import {datePipe, ValidationItem} from '../../../../../../shared/pipes';
import {RegExps} from '../../../../../../shared/constants/regexps';
import {EsiaRegCardForm, FormFieldConfig, KidSubform} from '../model';
import {InputMaskTypes} from '../../../../../../shared/components/baseField';
import {Sex} from '../../../../../../shared/models/profile/sex';
import {Platform} from 'react-native';

export const kidSubformFieldsNames: Array<keyof KidSubform> = [
  'lastName',
  'firstName',
  'middleName',
  'birthDate',
  'birthPlace',
  'sex',
  'address',
  'mobilePhone',
  'email',
  'number',
  'date',
  'org',
  'addressReg',
  'snils',
];

export const kidSubformFields: Record<
  keyof Omit<
    EsiaRegCardForm,
    'isEmailNotificationEnabled' | 'isSmsNotificationEnabled' | 'agentInfo' | 'isAccountLinkingEnabled' | 'codeOrg'
  >,
  FormFieldConfig
> = {
  firstName: {type: 'text', label: 'Имя'},
  lastName: {type: 'text', label: 'Фамилия'},
  middleName: {type: 'text', label: 'Отчество'},
  birthDate: {type: 'date', label: 'Дата рождения', formatter: datePipe},
  birthPlace: {type: 'text', label: 'Место рождения', editable: true},
  sex: {
    type: 'select',
    label: 'Пол',
    formatter: (val: Sex) => (Number(val) === Sex.male ? 'Мужской' : 'Женский'),
    values: [
      {id: Sex.male, value: Sex.male.toString(), label: 'Мужской'},
      {id: Sex.female, value: Sex.female.toString(), label: 'Женский'},
    ],
    variant: Platform.OS === 'web' ? 'outlined' : 'standard',
  },
  address: {type: 'text', label: 'Адрес проживания фактический', editable: true},
  mobilePhone: {type: 'text', label: 'Мобильный телефон', mask: InputMaskTypes.tel, editable: true},
  email: {
    type: 'text',
    label: 'Электронная почта',
    editable: true,
    format: (val: string) => {
      if (val === undefined) return '';
      if (val.length > 250) return val.slice(0, 250);
      return val;
    },
  },
  number: {type: 'text', label: 'Серия и номер'},
  date: {type: 'date', label: 'Дата выдачи', formatter: datePipe},
  org: {type: 'text', label: 'Кем выдан'},
  addressReg: {type: 'text', label: 'Адрес регистрации'},
  snils: {type: 'text', label: 'СНИЛС', mask: InputMaskTypes.snils},
};

export const validationItems: ValidationItem[] = [
  {
    names: 'lastName',
    error: 'Фамилия обязательна',
    type: 'required',
  },
  {
    names: 'firstName',
    error: 'Имя обязательно',
    type: 'required',
  },
  {
    names: 'birthDate',
    error: 'Дата рождения обязательна',
    type: 'required',
  },
  {
    names: 'birthPlace',
    error: 'Место рождения обязательно',
    type: 'required',
  },
  {
    names: 'address',
    error: 'Адрес обязательное поле',
    type: 'required',
  },
  {
    names: 'number',
    error: 'Серия и номер обязательное поле',
    type: 'required',
  },
  {
    names: 'date',
    error: 'Дата выдачи обязательное поле',
    type: 'required',
  },
  {
    names: 'org',
    error: 'Кем выдан обязательное поле',
    type: 'required',
  },
  {
    names: 'snils',
    error: 'Неправильно задан СНИЛС',
    type: 'custom',
    validator: (value: string) => RegExps.digits.test(value) && value.length === 11,
  },
  {
    names: 'mobilePhone',
    error: 'Неправильно задан телефон',
    type: 'custom',
    validator: (value: string) => RegExps.digits.test(value) && value.length === 11,
  },
  {
    names: 'email',
    error: 'Неправильный адрес электронной почты',
    type: 'pattern',
    pattern: RegExps.email,
  },
];
